export function validar(
    clienteIIBB,
    excencionesDePadron,
    excencionesFueraPadron
){
    // console.log("Voy a validar.......")
    // console.log("CLIENTE IIBB ACA: " , clienteIIBB)
    const excenciones=[...excencionesDePadron, ...excencionesFueraPadron]
    const errores= []

    const provFaltantes=clienteIIBB.filter((reg)=> (!!reg.percepcion || !!reg.porcentaje_excencion || !!reg.vto_excencion) && (!reg.id_provincia || !reg.id_provincia==="") )
    if(provFaltantes.length>0){
        errores.push("Completar Provincia")
    }

    const percepcionesFaltantes=clienteIIBB.filter((reg)=> (!!reg.id_provincia || !!reg.porcentaje_excencion || !!reg.vto_excencion)&& !reg.percepcion || reg.percepcion <= 0)
    if(percepcionesFaltantes.length>0){
        errores.push("Completar Alícuota Percepción")
    }

    const erroresPorcentajesExcencion=excenciones.filter((excencion)=>excencion.porcentaje_excencion > 100 || excencion.porcentaje_excencion==="0" || excencion.porcentaje_excencion==="00" || excencion.porcentaje_excencion==="000" )
    if(erroresPorcentajesExcencion.length>0){
        errores.push("Ningun porcentaje debe ser 0 o mayor a 100")
    }

    const faltaVtoExcencion=excenciones.filter((excencion)=>!!excencion.porcentaje_excencion && !excencion.vto_excencion)
    if(faltaVtoExcencion.length>0){
        errores.push("Completar Fecha Vencimiento Excención")
    }
    
    const faltaPorcExcencion=excenciones.filter((excencion)=>!!excencion.vto_excencion && !excencion.porcentaje_excencion)
    if(faltaPorcExcencion.length>0){
        errores.push("Completar Porcentaje Excención")
    }

    const faltaInicioVigencia=clienteIIBB.filter((reg)=>reg.fecha_vigencia_desde==="" || reg.fecha_vigencia_desde=== null)
    if(faltaInicioVigencia.length>0){
        errores.push("Completar Fecha Inicio Vigencia")
    }

    
    // const faltaFinVigencia=clienteIIBB.filter((reg)=>reg.fecha_vigencia_hasta==="" || reg.fecha_vigencia_hasta === null)
    // if(faltaInicioVigencia.length>0){
    //     errores.push("Completar Fecha Fin Vigencia")
    // }
    return errores;
}

export function validarInscripciones(inscripcionesIIBB){
    const errores = [];
    if(inscripcionesIIBB.some(inscripcion=>!inscripcion.id_provincia)) errores.push("Completar Provincia");
    if(inscripcionesIIBB.some(inscripcion=>!inscripcion.fecha_vigencia_desde)) errores.push("Completar fecha de inicio de vigencia");
    if(inscripcionesIIBB.some(inscripcion=>typeof(inscripcion.percepcion)==="string")) errores.push("Completar percepción");
    if(inscripcionesIIBB.some(inscripcion=>!inscripcion.coeficiente_unificado)) errores.push("Completar coeficiente unificado");
    if(inscripcionesIIBB.some(inscripcion=>!inscripcion.coeficiente_unificado > 1)) errores.push("El coeficiente unificado no puede ser mayor a 1");
    
    return errores;
}
